<template>
	<div class="become_vip">
		<Fontnavbar title="领取优惠券" />
		<!-- 优惠券 -->
		<div class="coupon">
			<div class="con_list" v-for="(item,index) in couponLits" :key="index" @click="getCoup(item.id)">
				<div class="money">{{ item.coupon_name }}</div>
				<div class="time">{{ item.end_date_text }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getUserInfo,
		getPublic,
		getAction
	} from "../../api.js";
	import {
		post
	} from "../../request.js";
	import Fontnavbar from "../../components/Navbar.vue";
	import {
		Dialog,
		Toast
	} from 'vant'

	// 节流函数
	function throttle(fn, interval) {
		var _self = fn, // 保存需要被延迟执行的函数引用
			timer, // 定时器
			firstTime = true; // 是否是第一次调用
		return function() {
			var args = arguments;
			var _me = this;
			if (firstTime) { // 如果是第一次调用不需要延迟
				_self.apply(_me, args); // 执行fn函数并且修正此函数中this所运行的上下文指向
				return firstTime = false;
			}
			if (timer) { // 如果定时器还在，说明前一次延迟执行还没有完成
				return false;
			}
			timer = setTimeout(function() { // 延迟一段时间执行
				clearTimeout(timer);
				timer = null;
				_self.apply(_me, args); // 执行fn函数并且修正此函数中this所运行的上下文指向
			}, interval || 2000);
		}
	}
	export default {
		components: {
			Fontnavbar,
			[Toast.name]: Toast
		},
		data() {
			return {
				// 设置虚假数据，进行循环
				couponLits: [],
				end_date_text: '领取之日后5天有效', //有效期时间
				coupon_name: '满100减2', //满减卷金额
			};
		},
		created() {
			this.getCpupList()
		},
		methods: {
			// 获取全部优惠券
			getCpupList() {
				post(getUserInfo, {}).then((res) => {
					if (res.code == 200) {
						post(getPublic, {}).then((res) => {
							if (res.code == 200) {
								this.couponLits = res.data
							}
						})
					} else if (res.code == 201) {
						Dialog({
							message: '您当前未登录'
						})
						setTimeout(() => {
							this.$router.replace({
								path: '/user/login'
							})
						}, 1000)
					}
				})

			},
			// 领取优惠券
			getCoup: throttle(function(id) {
				var data = {
					coupon_id: id
				}
				post(getAction, data).then((res) => {
					console.log(res);
					if (res.code == 200) {
						Toast(res.msg);
					} else if (res.code == 400) {
						Toast(res.msg);
					}
				})
			})
		}
	}
</script>

<style lang="less" scoped>
	.become_vip {

		.coupon {
			width: 100%;
			height: 100%;
			padding: 1rem;
			box-sizing: border-box;

			.con_list {
				width: 100%;
				height: 6rem;
				background-image: url('/static/enterGeneral.png');
				background-repeat: no-repeat;
				background-size: 100% 100%;
				margin-bottom: .5rem;
				padding: 1rem;
				padding-left: 2rem;
				box-sizing: border-box;
				display: flex;
				flex-flow: column;
				justify-content: space-around;
				align-items: flex-start;
				color: #fff;

				.money {
					font-size: 1.7rem;
					font-weight: 600;

				}

				.time {
					font-size: .8rem;
					font-weight: 400;
				}
			}
		}
	}
</style>